module.exports = __webpack_public_path__ + "fonts/5f8a077b674fd55bfb19713a06aa2add.ttf";